import React from 'react'
import { Card } from './Card'

export const WhatWeDo = () => {
    const tasks = [
        {
            label: "Kanban",
            description: "Visualize the state of your job search in a kanban board. See how many applications, interviews and offers you’ve received in one view.",
            image: "https://huntr.co/images/huntr-feature-kanban.png"
        },
        {
            label: "Collects jobs from across the web",
            description: "Our Chrome Extension can save jobs from large job sites like Indeed and LinkedIn to small startup career pages.",
            image: "https://huntr.co/images/huntr-feature-chrome.png"
        },
        {
            label: "Manage tasks",
            description: "Track everything you need to do to get your dream job, from polishing your resume to preparing for the big interview.",
            image: "https://huntr.co/images/huntr-feature-tasks.png"
        },
        {
            label: "Manage contacts",
            description: "Keep contact information for anyone you interact with during your search, from interviewers to recruiters and everyone in between.",
            image: "https://huntr.co/images/huntr-feature-contacts.png"
        },
        {
            label: "Take notes",
            description: "Document your job search journey and keep important job information handy with notes.",
            image: "https://huntr.co/images/huntr-feature-chrome.png"
        },
        {
            label: "Activity tracking",
            description: "View a full timeline of all your job search activities from application to offer accepted.",
            image: "https://huntr.co/images/huntr-feature-activity-tracking.png"
        },
    ]
  return (
    <>
        {tasks.map((task, id) => (<Card key={id} task={task}/>))}
    </>
  )
}
